module.exports = __webpack_public_path__ + "img/burger.0b392fa3.svg";